'use client'

import { useEffect, useRef, type KeyboardEvent } from 'react'
import classNames from 'classnames'
import ErrorBoundary from '@dustin-web/microsite-components/src/utils/error-boundary'
import {
  useTranslations,
  useLayout,
  LayoutHeaderActionType,
} from '@dustin-web/microsite-components/src/hooks'
import { useHeaderContext, DesktopStateActionType } from './header-context'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'
import { NavigationEventType } from '@dustin-web/microsite-components/src/utils/digital-data-types'

const SolutionsNav = () => {
  const firstRender = useRef<boolean>(true)
  const { translate } = useTranslations()
  const { dispatchDesktop, desktop } = useHeaderContext()
  const { dispatchHeader } = useLayout()
  const isActive: boolean = desktop.activeMegaMenu === 'solutions'
  const onSolutionsClick = () => {
    dispatchHeader({
      type: LayoutHeaderActionType.SET_ACTIVE_SUB_MENU,
      payload: { subMenu: null },
    })

    dispatchDesktop({
      type: DesktopStateActionType.SET_ACTIVE_MEGA_MENU,
      payload: {
        activeMegaMenu: isActive ? '' : 'solutions',
      },
    })
  }

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      return
    }
    DigitalData.pushNavigationInteraction(
      NavigationEventType.MainMenu,
      'services',
      isActive ? 'open_menu' : 'close_menu'
    )
  }, [isActive])

  const handleEnterKey = (event: KeyboardEvent<HTMLButtonElement>) => {
    if (event.key !== 'Enter') {
      return
    }

    if (desktop.activeMegaMenu === 'solutions') {
      event.preventDefault()
    }

    dispatchDesktop({
      type: DesktopStateActionType.SET_FOCUS_MEGA_MENU,
      payload: {
        focusMegaMenu: 'solutions',
      },
    })
  }

  return (
    <ErrorBoundary>
      <li className="c-header__navigation-item">
        <button
          data-ga-title="solutions"
          aria-expanded={isActive}
          className={classNames('c-header__navigation-btn button-stripped js-mega-menu-trigger', {
            'c-header__navigation-btn--active': isActive,
          })}
          onKeyDown={handleEnterKey}
          onClick={onSolutionsClick}>
          {translate('Header_Solutions')}
        </button>
      </li>
    </ErrorBoundary>
  )
}

export default SolutionsNav
